export const limitTextWithErrorToast = (
  text: string,
  maxLength: number,
  toasts: any,
  t: any
): string => {

  if (text?.length > maxLength) {
      toasts.error(t('project_edit.max_title_length_error', { length: maxLength }));
      return text?.slice(0, maxLength);
  }

  return text
}export const limitTextWithErrorToast = (
  text: string,
  maxLength: number,
  toasts: any,
  t: any
): string => {

  if (text?.length > maxLength) {
      toasts.error(t('project_edit.max_title_length_error', { length: maxLength }));
      return text?.slice(0, maxLength);
  }

  return text
}